import { render } from "./3.MaibCalculator.vue?vue&type=template&id=648badd9&scoped=true"
import script from "./3.MaibCalculator.vue?vue&type=script&lang=js"
export * from "./3.MaibCalculator.vue?vue&type=script&lang=js"

import "./3.MaibCalculator.vue?vue&type=style&index=0&id=648badd9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-648badd9"]])

export default __exports__